import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/index";
import Hero from "./components/Hero";

import ValueProposition from "./components/ValueProposition";
import Services from "./components/Services";
import SocialProof from "./components/SocialProof";
import Technology from "./components/Technology";
import Speed from "./components/Speed";
import Projects from "./components/Projects";
import Pricing from "./components/Pricing";
import News from "./components/News";
import Company from "./components/Company";
import CompanyAbout from "./components/CompanyAbout";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Privacy from "./components/Privacy";
import Security from "./components/Security";
import SpecifiedCommercialTransactions from "./components/SpecifiedCommercialTransactions";
import ShareNewsDetail from "./components/ShareNewsDetail";
import KigasuruDetail from "./components/news/details/KigasuruDetail";
import ChoryokuDetail from "./components/news/details/ChoryokuDetail";
import ShareWhitelabelDetail from "./components/news/details/ShareWhitelabelDetail";
import KanjiNameDetail from "./components/news/details/KanjiNameDetail";
import RinechanDetail from "./components/news/details/RinechanDetail";
import AwaseruDetail from "./components/news/details/AwaseruDetail";
import Sitemap from "./components/Sitemap/index";
import MethodPage from "./components/method/MethodPage";
import Careers from "./components/careers";
import ApplicationForm from "./components/careers/ApplicationForm";
import { HelmetProvider } from "react-helmet-async";
import RootLayout from "./layouts/RootLayout";

const MainLayout = () => {
  useEffect(() => {
    if (window.location.hash) {
      const scrollToHash = () => {
        const element = document.querySelector(window.location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };
      setTimeout(scrollToHash, 100);
      setTimeout(scrollToHash, 500);
    }
  }, []);

  const Divider = () => (
    <div className="container mx-auto px-4">
      <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D5D2CC] to-transparent" />
    </div>
  );

  return (
    <div className="relative min-h-screen bg-[#F5F3EF]">
      <div className="relative z-10">
        <Header />
        <Hero />
        <div className="bg-[#F5F3EF]">
          <ValueProposition />
          <Divider />
          <Services />
          <Divider />
          <SocialProof />
          <Divider />
          <Technology />
          <Divider />
          <Speed />
          <Divider />
          <Projects />
          <Divider />
          <Pricing />
          <Divider />
          <Company />
          <Divider />
          <News />
          <Divider />
          <Contact />
          <Footer />
        </div>
      </div>
    </div>
  );
};

const ValuesLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="relative min-h-screen bg-[#F5F3EF]">
      <div className="relative z-10">
        <Header />
        {children}
        <Footer />
      </div>
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <RootLayout>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<MainLayout />} />

            {/* Company Routes */}
            <Route
              path="/company/about"
              element={
                <ValuesLayout>
                  <CompanyAbout />
                </ValuesLayout>
              }
            />
            <Route
              path="/company/news"
              element={
                <ValuesLayout>
                  <News standalone />
                </ValuesLayout>
              }
            />

            {/* Other Routes */}
            <Route
              path="/pricing"
              element={
                <ValuesLayout>
                  <Pricing standalone />
                </ValuesLayout>
              }
            />
            {/* Method */}
            <Route
              path="/method"
              element={
                <ValuesLayout>
                  <MethodPage />
                </ValuesLayout>
              }
            />

            <Route
              path="/privacy"
              element={
                <ValuesLayout>
                  <Privacy />
                </ValuesLayout>
              }
            />
            <Route
              path="/security"
              element={
                <ValuesLayout>
                  <Security />
                </ValuesLayout>
              }
            />
            <Route
              path="/specified-commercial-transactions"
              element={
                <ValuesLayout>
                  <SpecifiedCommercialTransactions />
                </ValuesLayout>
              }
            />
            <Route
              path="/news/share-release"
              element={
                <ValuesLayout>
                  <ShareNewsDetail />
                </ValuesLayout>
              }
            />
            <Route
              path="/news/kigasuru-release"
              element={
                <ValuesLayout>
                  <KigasuruDetail />
                </ValuesLayout>
              }
            />
            <Route
              path="/news/choryoku-release"
              element={
                <ValuesLayout>
                  <ChoryokuDetail />
                </ValuesLayout>
              }
            />
            <Route
              path="/news/share-whitelabel"
              element={
                <ValuesLayout>
                  <ShareWhitelabelDetail />
                </ValuesLayout>
              }
            />
            <Route
              path="/news/kanjiname-release"
              element={
                <ValuesLayout>
                  <KanjiNameDetail />
                </ValuesLayout>
              }
            />
            <Route
              path="/news/rinechan-release"
              element={
                <ValuesLayout>
                  <RinechanDetail />
                </ValuesLayout>
              }
            />
            <Route
              path="/news/awaseru-release"
              element={
                <ValuesLayout>
                  <AwaseruDetail />
                </ValuesLayout>
              }
            />
            <Route
              path="/sitemap"
              element={
                <ValuesLayout>
                  <Sitemap />
                </ValuesLayout>
              }
            />
            <Route
              path="/careers"
              element={
                <ValuesLayout>
                  <Careers />
                </ValuesLayout>
              }
            />
            <Route path="/careers/apply" element={<ApplicationForm />} />
          </Routes>
        </Router>
      </RootLayout>
    </HelmetProvider>
  );
}

export default App;